<template>
  <footer
    ref="footerRef"
    class="footer"
    :class="{ 'footer--visible': isVisible }"
  >
    <div class="footer-separator"></div>

    <div class="footer-glow footer-glow--left"></div>
    <div class="footer-glow footer-glow--right"></div>

    <div class="footer-inner">
      <div class="footer-main">
        <div class="footer-group social-group">
          <p class="group-title">
            Мы в социальных сетях
          </p>

          <div class="social-links">
            <a
              href="https://t.me/hyperappstore"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link"
              aria-label="Открыть Telegram"
            >
              <span class="social-icon-wrapper">
                <img
                  src="/tg_icon.png"
                  alt=""
                  class="social-icon"
                />
              </span>

              <span class="social-content">
                <span class="social-name">
                  Telegram
                </span>

                <span class="social-caption">
                  Новости проекта
                </span>
              </span>

              <svg
                class="link-arrow"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 13L13 5M7 5H13V11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>

            <a
              href="https://instagram.com/hyper_app"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link"
              aria-label="Открыть Instagram"
            >
              <span class="social-icon-wrapper">
                <img
                  src="/ins_icon.png"
                  alt=""
                  class="social-icon"
                />
              </span>

              <span class="social-content">
                <span class="social-name">
                  Instagram
                </span>

                <span class="social-caption">
                  Жизнь команды
                </span>
              </span>

              <svg
                class="link-arrow"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 13L13 5M7 5H13V11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-side">
          <div class="app-download">
            <p class="group-title">
              Мобильное приложение
            </p>

            <p class="app-text">
              Скачивайте нас в App Store
            </p>

            <a
              href="https://apps.apple.com/ru/app/hyper/id1472576770"
              target="_blank"
              rel="noopener noreferrer"
              class="app-store-link"
              aria-label="Скачать приложение в App Store"
            >
              <img
                src="/appstore_icon.png"
                alt="Скачать в App Store"
                class="app-icon"
              />
            </a>
          </div>

          <div class="theme-block">
            <p class="group-title">
              Оформление
            </p>

            <button
              class="theme-switch"
              type="button"
              :aria-label="
                theme === 'dark'
                  ? 'Включить светлую тему'
                  : 'Включить тёмную тему'
              "
              @click="toggleTheme"
            >
              <span
                class="theme-option"
                :class="{
                  'theme-option--active':
                    theme === 'light',
                }"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="8.5"
                    cy="8.5"
                    r="3"
                    stroke="currentColor"
                    stroke-width="1.4"
                  />

                  <path
                    d="M8.5 1.5V3M8.5 14V15.5M1.5 8.5H3M14 8.5H15.5M3.55 3.55L4.65 4.65M12.35 12.35L13.45 13.45M13.45 3.55L12.35 4.65M4.65 12.35L3.55 13.45"
                    stroke="currentColor"
                    stroke-width="1.4"
                    stroke-linecap="round"
                  />
                </svg>

                <span>Светлая</span>
              </span>

              <span
                class="theme-option"
                :class="{
                  'theme-option--active':
                    theme === 'dark',
                }"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.2 10.8C13.4 11.2 12.5 11.4 11.6 11.4C8.3 11.4 5.6 8.7 5.6 5.4C5.6 4.5 5.8 3.6 6.2 2.8C3.6 3.7 1.8 6.1 1.8 8.9C1.8 12.5 4.7 15.4 8.3 15.4C11.1 15.4 13.5 13.6 14.2 10.8Z"
                    stroke="currentColor"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span>Тёмная</span>
              </span>

              <span
                class="theme-slider"
                :class="{
                  'theme-slider--dark':
                    theme === 'dark',
                }"
              ></span>
            </button>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="copyright">
          © 2026 Hr³. Все права защищены.
        </p>

        <nav
          class="footer-links"
          aria-label="Юридическая информация"
        >
          <button
            class="footer-link"
            type="button"
            @click="goToPrivacy"
          >
            Политика конфиденциальности
          </button>

          <span class="links-divider"></span>

          <button
            class="footer-link"
            type="button"
            @click="goToTerms"
          >
            Условия использования
          </button>
        </nav>

        <p class="made-with">
          Сделано независимо

          <span class="made-dot"></span>

          в России
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {
  onMounted,
  onUnmounted,
  ref,
} from "vue";

import { useRouter } from "vue-router";

const router = useRouter();

const footerRef = ref(null);
const isVisible = ref(false);

const theme = ref(
  document.documentElement.getAttribute(
    "data-theme"
  ) ||
    localStorage.getItem("theme") ||
    "light"
);

let visibilityObserver;
let themeObserver;

const goToPrivacy = () => {
  router.push("/privacy-policy");
};

const goToTerms = () => {
  router.push("/terms-of-use");
};

const toggleTheme = () => {
  const newTheme =
    theme.value === "dark"
      ? "light"
      : "dark";

  theme.value = newTheme;

  document.documentElement.setAttribute(
    "data-theme",
    newTheme
  );

  localStorage.setItem("theme", newTheme);
};

onMounted(() => {
  document.documentElement.setAttribute(
    "data-theme",
    theme.value
  );

  themeObserver = new MutationObserver(() => {
    theme.value =
      document.documentElement.getAttribute(
        "data-theme"
      ) || "light";
  });

  themeObserver.observe(
    document.documentElement,
    {
      attributes: true,
      attributeFilter: ["data-theme"],
    }
  );

  visibilityObserver =
    new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          return;
        }

        isVisible.value = true;
        visibilityObserver?.disconnect();
      },
      {
        threshold: 0.12,
      }
    );

  if (footerRef.value) {
    visibilityObserver.observe(
      footerRef.value
    );
  }
});

onUnmounted(() => {
  visibilityObserver?.disconnect();
  themeObserver?.disconnect();
});
</script>

<style scoped>
.footer {
  position: relative;

  width: 100%;

  overflow: hidden;

  background:
    color-mix(
      in srgb,
      var(--footer-bg) 94%,
      var(--primary-color) 6%
    );
}

.footer-separator {
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 1px;

  background: var(--separator_home);
}

.footer-glow {
  position: absolute;

  width: 500px;
  height: 500px;

  border-radius: 50%;

  pointer-events: none;

  filter: blur(115px);

  opacity: 0.075;

  background: #2277e6;

  animation:
    glow-movement 13s ease-in-out infinite;
}

.footer-glow--left {
  left: -320px;
  bottom: -370px;
}

.footer-glow--right {
  top: -370px;
  right: -320px;

  animation-delay: -6.5s;
}

.footer-inner {
  position: relative;
  z-index: 2;

  width: 1200px;
  max-width: calc(100% - 48px);

  margin: 0 auto;

  padding: 64px 0 28px;

  box-sizing: border-box;
}

/* ========================= */
/* ОСНОВНАЯ ЧАСТЬ */
/* ========================= */

.footer-main {
  display: grid;
  grid-template-columns:
    minmax(420px, 1fr)
    minmax(460px, 0.95fr);

  align-items: end;

  gap: 100px;
}

.footer-group,
.footer-side {
  opacity: 0;
  transform: translateY(22px);

  transition:
    opacity 0.8s ease,
    transform 0.8s
      cubic-bezier(0.22, 1, 0.36, 1);
}

.footer-side {
  transition-delay: 0.1s;
}

.footer--visible .footer-group,
.footer--visible .footer-side {
  opacity: 1;
  transform: translateY(0);
}

.group-title {
  margin: 0 0 14px;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: -0.2px;
  text-transform: uppercase;

  color:
    color-mix(
      in srgb,
      var(--text) 42%,
      transparent
    );
}

/* ========================= */
/* СОЦИАЛЬНЫЕ СЕТИ */
/* ========================= */

.social-links {
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 10px;
}

.social-link {
  position: relative;

  min-height: 72px;

  display: flex;
  align-items: center;

  padding: 12px 14px;

  box-sizing: border-box;

  border:
    1px solid
    color-mix(
      in srgb,
      var(--text) 7%,
      transparent
    );

  border-radius: 18px;

  color: var(--text);
  text-decoration: none;

  background:
    color-mix(
      in srgb,
      var(--footer-bg) 82%,
      transparent
    );

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  transition:
    transform 0.25s ease,
    border-color 0.25s ease,
    background-color 0.25s ease,
    box-shadow 0.25s ease;
}

.social-link:hover {
  transform: translateY(-3px);

  border-color:
    color-mix(
      in srgb,
      #2277e6 24%,
      transparent
    );

  background:
    color-mix(
      in srgb,
      var(--footer-bg) 88%,
      #2277e6 4%
    );

  box-shadow:
    0 16px 36px
    color-mix(
      in srgb,
      #2277e6 10%,
      transparent
    );
}

.social-icon-wrapper {
  width: 42px;
  height: 42px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 13px;

  background:
    color-mix(
      in srgb,
      var(--text) 5%,
      transparent
    );
}

.social-icon {
  width: 23px;
  height: 23px;

  object-fit: contain;

  transition:
    transform 0.25s
      cubic-bezier(0.22, 1, 0.36, 1);
}

.social-link:hover .social-icon {
  transform:
    scale(1.08)
    rotate(-3deg);
}

.social-content {
  min-width: 0;

  display: flex;
  flex-direction: column;

  margin-left: 12px;
}

.social-name {
  font-family: "Eastman-Medium", sans-serif;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: -0.3px;
}

.social-caption {
  margin-top: 4px;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 11px;
  line-height: 1.2;

  color:
    color-mix(
      in srgb,
      var(--text) 42%,
      transparent
    );
}

.link-arrow {
  flex-shrink: 0;

  margin-left: auto;

  color:
    color-mix(
      in srgb,
      var(--text) 36%,
      transparent
    );

  transition:
    transform 0.25s ease,
    color 0.25s ease;
}

.social-link:hover .link-arrow {
  color: #2277e6;

  transform: translate(2px, -2px);
}

/* ========================= */
/* APP STORE + ТЕМА */
/* ========================= */

.footer-side {
  display: grid;
  grid-template-columns: auto auto;

  align-items: end;
  justify-content: end;

  gap: 48px;
}

.app-download {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.app-text {
  margin: 0 0 12px;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: -0.3px;

  color:
    color-mix(
      in srgb,
      var(--text) 56%,
      transparent
    );
}

.app-store-link {
  display: inline-block;

  border-radius: 9px;

  transition:
    transform 0.25s
      cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.25s ease,
    box-shadow 0.25s ease;
}

.app-store-link:hover {
  transform: translateY(-2px);

  box-shadow:
    0 12px 28px
    rgba(0, 0, 0, 0.12);
}

.app-store-link:active {
  transform: scale(0.97);
}

.app-icon {
  width: 114px;
  height: auto;

  display: block;
}

.theme-block {
  display: flex;
  flex-direction: column;
}

/* ========================= */
/* ПЕРЕКЛЮЧАТЕЛЬ ТЕМЫ */
/* ========================= */

.theme-switch {
  position: relative;

  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 236px;
  height: 44px;

  flex-shrink: 0;

  padding: 4px;

  border:
    1px solid
    color-mix(
      in srgb,
      var(--text) 7%,
      transparent
    );

  border-radius: 14px;

  background:
    color-mix(
      in srgb,
      var(--text) 4%,
      transparent
    );

  cursor: pointer;

  isolation: isolate;
}

.theme-option {
  position: relative;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 7px;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 12px;
  letter-spacing: -0.2px;

  color:
    color-mix(
      in srgb,
      var(--text) 42%,
      transparent
    );

  transition: color 0.3s ease;
}

.theme-option--active {
  color: var(--text);
}

.theme-slider {
  position: absolute;
  z-index: 1;

  top: 4px;
  left: 4px;

  width: calc(50% - 4px);
  height: 34px;

  border-radius: 10px;

  background:
    color-mix(
      in srgb,
      var(--footer-bg) 92%,
      var(--text) 8%
    );

  box-shadow:
    0 4px 12px
    color-mix(
      in srgb,
      #000000 8%,
      transparent
    );

  transition:
    transform 0.35s
      cubic-bezier(0.22, 1, 0.36, 1);
}

.theme-slider--dark {
  transform: translateX(100%);
}

/* ========================= */
/* НИЖНЯЯ ЧАСТЬ */
/* ========================= */

.footer-bottom {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  gap: 24px;

  margin-top: 58px;
  padding-top: 27px;

  border-top:
    1px solid
    color-mix(
      in srgb,
      var(--text) 6%,
      transparent
    );

  opacity: 0;
  transform: translateY(14px);

  transition:
    opacity 0.8s 0.22s ease,
    transform 0.8s 0.22s
      cubic-bezier(0.22, 1, 0.36, 1);
}

.footer--visible .footer-bottom {
  opacity: 1;
  transform: translateY(0);
}

.copyright,
.made-with {
  margin: 0;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: -0.15px;

  color:
    color-mix(
      in srgb,
      var(--text) 36%,
      transparent
    );
}

.made-with {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 7px;

  text-align: right;
}

.made-dot {
  width: 3px;
  height: 3px;

  flex-shrink: 0;

  border-radius: 50%;

  background:
    color-mix(
      in srgb,
      var(--text) 30%,
      transparent
    );
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 14px;
}

.footer-link {
  position: relative;

  padding: 0;

  border: 0;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: -0.15px;

  color:
    color-mix(
      in srgb,
      var(--text) 48%,
      transparent
    );

  background: transparent;

  cursor: pointer;

  transition: color 0.2s ease;
}

.footer-link::after {
  content: "";

  position: absolute;

  left: 0;
  right: 0;
  bottom: -3px;

  height: 1px;

  background: #2277e6;

  transform: scaleX(0);
  transform-origin: right;

  transition:
    transform 0.3s
      cubic-bezier(0.22, 1, 0.36, 1);
}

.footer-link:hover {
  color: #2277e6;
}

.footer-link:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.links-divider {
  width: 3px;
  height: 3px;

  border-radius: 50%;

  background:
    color-mix(
      in srgb,
      var(--text) 18%,
      transparent
    );
}

/* ========================= */
/* АНИМАЦИИ */
/* ========================= */

@keyframes glow-movement {
  0%,
  100% {
    transform:
      translate3d(0, 0, 0)
      scale(1);
  }

  50% {
    transform:
      translate3d(28px, -18px, 0)
      scale(1.08);
  }
}

/* ========================= */
/* TABLET */
/* ========================= */

@media (max-width: 1050px) {
  .footer-main {
    grid-template-columns: 1fr;

    gap: 46px;
  }

  .footer-side {
    justify-content: space-between;

    grid-template-columns: auto auto;
  }
}

/* ========================= */
/* MOBILE */
/* ========================= */

@media (max-width: 768px) {
  .footer-inner {
    width: 100%;
    max-width: 100%;

    padding: 48px 16px 24px;
  }

  .footer-main {
    gap: 38px;
  }

  .social-links {
    grid-template-columns: 1fr;

    gap: 9px;
  }

  .social-link {
    min-height: 68px;
  }

  .footer-side {
    grid-template-columns: 1fr;

    justify-content: stretch;

    gap: 32px;
  }

  .app-download,
  .theme-block {
    width: 100%;
  }

  .app-icon {
    width: 120px;
  }

  .theme-switch {
    width: 100%;
  }

  .footer-bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    gap: 16px;

    margin-top: 42px;
    padding-top: 23px;
  }

  .footer-links {
    align-items: flex-start;
    flex-direction: column;

    gap: 10px;
  }

  .links-divider {
    display: none;
  }

  .made-with {
    justify-content: flex-start;

    text-align: left;
  }
}

@media (max-width: 430px) {
  .footer-inner {
    padding-top: 42px;
  }

  .social-link {
    min-height: 64px;
  }
}

/* ========================= */
/* REDUCED MOTION */
/* ========================= */

@media (prefers-reduced-motion: reduce) {
  .footer-glow {
    animation: none !important;
  }

  .footer-group,
  .footer-side,
  .footer-bottom,
  .theme-slider,
  .social-link,
  .social-icon,
  .link-arrow,
  .app-store-link {
    transition-duration: 0.01ms !important;
  }
}
</style>